import React from "react";
import Layout from "../../components/Layout";
import Flex from "../../components/Flex";
import DefaultBreadcrumbs from "../../components/DefaultBreadcrumbs";
import Container from "../../components/Container";
import Content from "../../components/Content";
import ButtonList from "../../components/ButtonList";
import LinkButton from "../../components/LinkButton";
import { useHistory } from "react-router-dom";
import { useAuthState } from "../../components/AuthProvider";
import Card from "../../components/Card";

import styles from "./Admin.module.scss";

const Admin = () => {
  const { user } = useAuthState();
  const history = useHistory();

  return (
    <Layout>
      <div className={styles.base}>
        <Container className={styles.admin}>
          <Flex gutter={3}>
            <Flex.Item span={12}>
              <DefaultBreadcrumbs />
            </Flex.Item>
            <Flex.Item span={12}>
              <Content>
                <h1>Adminstration</h1>
              </Content>
            </Flex.Item>

            <Flex.Item span={6}>
              <Card className={styles.card}>
                <Content>
                  <h2 className={styles.title}>Organizations</h2>
                  <div className={styles.records}>
                    <div className={styles.count}>{user.clients.length}</div>
                    <p>Account Records</p>
                  </div>
                  <ButtonList className={styles.icons}>
                    <LinkButton
                      icon="list"
                      onClick={() => {
                        history.push("/admin/organizations");
                      }}
                    >
                      List
                    </LinkButton>
                    <LinkButton
                      icon="add"
                      disabled={user.role === "Global Admin" ? false : true}
                      onClick={() => {
                        history.push("admin/organizations/add");
                      }}
                    >
                      Add
                    </LinkButton>
                  </ButtonList>
                </Content>
              </Card>
            </Flex.Item>
            <Flex.Item span={6}>
              <Card className={styles.card}>
                <Content>
                  <h2 className={styles.title}>Users</h2>
                  <div className={styles.records}>
                    <div className={styles.count}>xx</div>
                    <p>User Records</p>
                  </div>
                  <ButtonList className={styles.icons}>
                    <LinkButton
                      icon="list"
                      onClick={() => {
                        history.push("/admin/users");
                      }}
                    >
                      List
                    </LinkButton>
                    <LinkButton
                      icon="add"
                      onClick={() => {
                        history.push("/admin/users/add");
                      }}
                    >
                      Add
                    </LinkButton>
                  </ButtonList>
                </Content>
              </Card>
            </Flex.Item>
            <Flex.Item span={6}>
              <Card className={styles.card}>
                <Content>
                  <h2 className={styles.title}>External Vendors</h2>
                  <div className={styles.records}>
                    <div className={styles.count}>xx</div>
                    <p>External Vendor Records</p>
                  </div>
                  <ButtonList className={styles.icons}>
                    <LinkButton
                      icon="list"
                      onClick={() => {
                        history.push("/admin/externalvendors");
                      }}
                    >
                      List
                    </LinkButton>
                    <LinkButton
                      icon="add"
                      onClick={() => {
                        history.push("/admin/externalvendors/add");
                      }}
                    >
                      Add
                    </LinkButton>
                  </ButtonList>
                </Content>
              </Card>
            </Flex.Item>
          </Flex>
        </Container>
      </div>
    </Layout>
  );
};

export default Admin;
